const article_quote_bubble = () => {
  const selector = 'article_quote_bubble';
  const instances = document.querySelectorAll(`.${selector}`);

  const getElement = (type = 'div', classString, text) => {
    const el = document.createElement(type);
    if (classString) {
      el.classList.add(classString);
    }
    if (text) {
      el.innerText = text;
    }
    return el;
  };

  const renderCitationContainer = (instance, cite, creds) => {
    // Render container
    const container = getElement(
      'footer',
      'article_quote_bubble-citation_container',
      null,
    );
    instance.appendChild(container);

    if (cite) {
      const citation = getElement(
        'span',
        'article_quote_bubble-citation',
        cite,
      );
      container.appendChild(citation);
    }

    if (cite && creds) {
      const slash = getElement('span', null, ' • ');
      container.appendChild(slash);
    }

    if (creds) {
      const credentials = getElement(
        'span',
        'article_quote_bubble-credentials',
        creds,
      );
      container.appendChild(credentials);
    }
  };

  const renderData = instance => {
    const allChildren = instance.querySelectorAll('*');
    const dataCitation = instance.getAttribute('data-citation');
    const dataCredentials = instance.getAttribute('data-credentials');

    // Grid
    const grid = document.createElement('div');
    grid.classList.add('article_quote_bubble-grid');
    instance.appendChild(grid);

    // Quotation marks
    const quoteMarks = getElement(
      'img',
      'article_quote_bubble-quotation_marks',
      null,
    );
    quoteMarks.src = '/assets/img/icon-article_quote_bubble.svg';
    quoteMarks.alt = 'Quotation Marks Icon';
    grid.appendChild(quoteMarks);

    // Content container
    const contentContainer = getElement(
      'div',
      'article_quote_bubble-content_container',
      null,
    );
    grid.appendChild(contentContainer);

    // Heading
    const heading = getElement(
      'h4',
      'article_quote_bubble-heading',
      instance.getAttribute('data-title'),
    );
    contentContainer.appendChild(heading);

    // Content
    Array.from(allChildren).forEach(child => {
      // Remove children
      child.parentNode.removeChild(child);

      // Insert childre in content container
      contentContainer.append(child);
    });

    if (dataCitation || dataCredentials) {
      renderCitationContainer(contentContainer, dataCitation, dataCredentials);
    }
  };

  // Loop through all components and output data
  instances.forEach(instance => renderData(instance));
};
article_quote_bubble();
